// Copyright (c) Mysten Labs, Inc.
// Modifications Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export type { SignedPersonalMessage, SignedTransaction } from '@iota/wallet-standard';
export type { ThemeVars } from './themes/themeContract.js';
